import type { CSSProperties } from 'vue'

import ShapeElement from './ShapeElement.vue'

import type { FlashcardSize, ShapeElementInput } from '../types'
import type { ElementDefinition } from '../runtime/elementDefinition'
import { scaleHeight, scaleWidth } from '../runtime/math'

const estimateShapeBox = (input: ShapeElementInput, size: FlashcardSize) => {
  const width = typeof input.width === 'number' ? input.width : 120
  const height = typeof input.height === 'number' ? input.height : 60
  const widthPx = scaleWidth(width, size)
  const heightPx = scaleHeight(height, size)
  if (!Number.isFinite(widthPx) || !Number.isFinite(heightPx) || widthPx <= 0 || heightPx <= 0) {
    return null
  }
  return { widthPx, heightPx }
}

const definition: ElementDefinition<ShapeElementInput> = {
  type: 'shape',
  component: ShapeElement,
  estimateBox: (input, size) => estimateShapeBox(input, size),
  toProps: (input, ctx) => {
    if (!ctx.baseStyle) return null

    const width = typeof input.width === 'number' ? input.width : 120
    const height = typeof input.height === 'number' ? input.height : 60
    const widthPx = scaleWidth(width, ctx.size)
    const heightPx = scaleHeight(height, ctx.size)
    if (!Number.isFinite(widthPx) || !Number.isFinite(heightPx) || widthPx <= 0 || heightPx <= 0) {
      return null
    }

    const style: CSSProperties = {
      ...ctx.baseStyle,
      width: `${widthPx}px`,
      height: `${heightPx}px`,
      display: 'block',
    }

    return {
      style,
      kind: input.kind ?? 'rect',
      fill: input.fill ?? 'rgba(59, 130, 246, 0.18)',
      stroke: input.stroke ?? 'rgba(59, 130, 246, 0.55)',
      strokeWidth: typeof input.strokeWidth === 'number' ? input.strokeWidth : 2,
      radius: typeof input.radius === 'number' ? input.radius : 12,
    }
  },
}

export default definition
